module.exports = __webpack_public_path__ + "7a688d8e91c6c0e0ab9a0ed1b3b0d4d0.svg";